import axios from 'axios';
import { ACCOUNT_DEACTIVATED } from '../../constants/authErrorCodes';
import { LOGIN_ENDPOINT } from './endpoints';

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const errorCode = error.response.data.error_code;
        const isSignInRequest = error.response.config.url === LOGIN_ENDPOINT;

        if (errorCode === ACCOUNT_DEACTIVATED) {
            if (!isSignInRequest) {
                window.location.href = `/sign-in?error=${ACCOUNT_DEACTIVATED}`;
            }
        }

        return Promise.reject(error);
    }
);

export default axios;
